import { Box, Grid, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomAvatar,
  CustomButton,
  CustomKeyValue,
} from "../../../components";
import i18n from "../../../i18n-config";
import { RootState } from "../../../store/state";
import theme from "../../../theme/theme";

function Profile() {
  const user = useSelector((state: RootState) => state.auth.user) as any;
  const dispatch = useDispatch();

  const logout = () => {
    dispatch({type: "USER_LOGGED_OUT"})
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        p: 10,
      }}
    >
      <Stack alignItems={"center"} mb={5}>
        <CustomAvatar
          avatarStyle={{ width: 100, height: 100, borderRadius: 100 }}
          rootStyle={{ marginBottom: 2 }}
        />
        <CustomButton title={i18n.t("update_picture")} />
      </Stack>
      <Grid container>
        <Grid item xs={6}>
          <Stack alignItems={"center"}>
            <CustomKeyValue
              title={i18n.t("nom")}
              value={user.nom || "N/a"}
              rootStyle={{ marginBottom: 15 }}
              titleStyle={{ fontSize: 16 }}
              valueStyle={{ fontSize: 25 }}
            />
            <CustomKeyValue
              title={i18n.t("telephone")}
              value={user.telephone || "N/a"}
              rootStyle={{ marginBottom: 15 }}
              titleStyle={{ fontSize: 16 }}
              valueStyle={{ fontSize: 25 }}
            />
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack alignItems={"center"}>
            <CustomKeyValue
              title={i18n.t("prenom")}
              value={user.prenom || "N/a"}
              rootStyle={{ marginBottom: 15 }}
              titleStyle={{ fontSize: 16 }}
              valueStyle={{ fontSize: 25 }}
            />
            <CustomKeyValue
              title={i18n.t("email")}
              value={user.email || "N/a"}
              rootStyle={{ marginBottom: 15 }}
              titleStyle={{ fontSize: 16 }}
              valueStyle={{ fontSize: 25 }}
            />
          </Stack>
        </Grid>
      </Grid>
      <Stack alignItems={"center"} mt={5}>
        <CustomButton
          title={i18n.t("logout")}
          rootStyle={{ backgroundColor: theme.colors.red }}
          onClick={logout}
        />
      </Stack>
    </Box>
  );
}

export default Profile;
